document.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body');
  const navBarEl = document.getElementById('main-nav');
  const headerContactEl = document.querySelector('.header-contact');
  const hasFullSizeBanner = body.classList.contains('has-fullsize-banner');

  if (!hasFullSizeBanner) {
      navBarEl.classList.add('bg-white');
      headerContactEl.classList.remove('btn-light');
      headerContactEl.classList.add('btn-primary');
      return 
  }
  
  handleNavScroll();

  document.addEventListener('scroll', handleNavScroll);

  function handleNavScroll() {
      if (window.scrollY > 21) {
          navBarEl.classList.add('bg-white');
          headerContactEl.classList.remove('btn-light');
          headerContactEl.classList.add('btn-primary');
      } else {
          navBarEl.classList.remove('bg-white');
          headerContactEl.classList.remove('btn-primary');
          headerContactEl.classList.add('btn-light');
      }
  }

  const compassDecoration = document.querySelector('.compass-decoration');

  if (hasFullSizeBanner) {
    document.addEventListener('scroll', handleCompassAnimation);
  }

  function handleCompassAnimation() {
    if (compassDecoration) {
      const scrollPos = window.scrollY
      const scrollPercentage = scrollPos / 10;

      if (scrollPos < screen.height)
        compassDecoration.style.transform = `rotate(${scrollPercentage}deg)`;

    } else {
      document.removeEventListener('scroll', handleCompassAnimation);
    }
  }

});

const $ = jQuery;

$(document).ready(() => {

  const owlCarousel = $('.owl-carousel').owlCarousel({
    dots: true,
    margin: 15,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 2,
        margin: 32,
      },
      1200: {
          margin: 32,
          items: 4
      }
    },
    onInitialized: function (event) {
      const count = event.item.count;
      if (event.item.count <= 4 && window.screen.width >= 1200) {
        this.settings.dots = false
      }
    }
  })


});